import { WarningOutlined } from '@ant-design/icons';
import StatsCard from 'components/new-ui/base/stats-card/StatsCard';
import TruckIconOutlined from 'components/icons/TruckIconOutlined';
import WeightIconOutlined from 'components/icons/WeightIconOutlined';
import { StatisticsProps } from 'types/common';

type Props = StatisticsProps & {};

const TeamManagerStatsCards = ({ data, error, loading, refetch }: Props) => {
    const manifestsCount = data?.manifestsStatistic.totalManifests;
    const activeManifests = data?.manifestsStatistic.activeManifests;
    const totalJobs = data?.jobsStatistic.totalJobs;
    const unassignedJobs = data?.jobsStatistic.notAssignedJobs;

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 24,
            }}
        >
            <StatsCard
                label="Manifests"
                type="warning"
                icon={<TruckIconOutlined style={{ color: 'var(--orange-6)' }} />}
                count={manifestsCount}
                loading={loading}
                error={Boolean(error)}
                onRefresh={refetch}
            />

            <StatsCard
                label="Active Manifests"
                type="success"
                icon={<TruckIconOutlined style={{ color: 'var(--polar-green-6)' }} />}
                count={activeManifests}
                loading={loading}
                error={Boolean(error)}
                onRefresh={refetch}
            />

            <StatsCard
                label="Total Jobs"
                type="default"
                icon={<WeightIconOutlined style={{ color: 'var(--blue-7)' }} />}
                count={totalJobs}
                loading={loading}
                error={Boolean(error)}
                onRefresh={refetch}
            />

            <StatsCard
                label="Not Assigned Jobs"
                type="error"
                icon={<WarningOutlined style={{ color: 'var(--dust-red-7)' }} />}
                count={unassignedJobs}
                loading={loading}
                error={Boolean(error)}
                onRefresh={refetch}
            />
        </div>
    );
};

export default TeamManagerStatsCards;
